// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1098":"55872799","2632":"ff2f5689","7513":"826d2477"}[chunkId] + ".chunk.css";
};